import Table from 'react-bootstrap/Table';

const FacultyRows = ({ faculty, isTeaching }) =>
  faculty
    .filter(({ Specialized_Subject }) =>
      isTeaching ? Specialized_Subject !== '' : Specialized_Subject === ''
    )
    .map((member, index) => (
      <tr key={member.id}>
          <td className="faculty-serial-cell">
            {index + 1}
          </td>
          <td className="faculty-photo-cell">
            <img
              className="faculty-table-photo"
              src={`${process.env.REACT_APP_API_URL}${member.Photo}`}
              width={isTeaching ? undefined : '80'}
              alt={member.Faculty_Name || 'Faculty member'}
            />
          </td>
          <td className="text-bold faculty-name-cell py-2">
            <span className="faculty-name">{member.Faculty_Name}</span>
            <br />
            {member.Jntuh_Id && (
              <span className="faculty-id">{member.Jntuh_Id}</span>
            )}
          </td>
          <td className="py-2">{member.Designation}</td>
          <td className="py-2">{member.Highest_Qualification}</td>
          <td className="py-2">
            {member.Exp_In_Year} {member.Exp_In_Month}
          </td>
          <td className="py-2">{member.Specialized_Subject}</td>
      </tr>
    ));

const FacultyTable = ({ faculty = [], isTeaching = true, title }) => {
  const staff = faculty.filter(({ Specialized_Subject }) =>
    isTeaching ? Specialized_Subject !== '' : Specialized_Subject === ''
  );

  if (staff.length === 0) {
    return null;
  }

  const table = (
    <Table responsive className="faculty-data-table">
      <colgroup>
        <col className="faculty-col-serial" />
        <col className="faculty-col-photo" />
        <col className="faculty-col-name" />
        <col className="faculty-col-designation" />
        <col className="faculty-col-qualification" />
        <col className="faculty-col-experience" />
        <col className="faculty-col-subject" />
      </colgroup>
      <thead className="bg-light-gradient">
        <tr>
          <th className="fontSmall fontBold faculty-serial-cell">S.No.</th>
          <th className="fontSmall fontBold">Photo</th>
          <th className="fontSmall fontBold">Faculty Name&nbsp; <small>(JNTUH ID)</small></th>
          <th className="fontSmall fontBold">Designation</th>
          <th className="fontSmall fontBold">Qualification</th>
          <th className="fontSmall fontBold">Experience</th>
          <th className="fontSmall fontBold">Specialized Subject</th>
        </tr>
      </thead>
      <tbody>
        <FacultyRows faculty={staff} isTeaching={isTeaching} />
      </tbody>
    </Table>
  );

  return (
    <section className="faculty-table-section">
      {title && (
        <div className="faculty-section-heading">
          <h5>{title}</h5>
        </div>
      )}
      {table}
    </section>
  );
};

export { FacultyTable };
export default FacultyTable;

